import { Component, Input, OnInit } from "@angular/core";
import { ClaimToolElementSaveChangesData } from "@shared/models/claim-tool-element-save-changes-data.model";
import { DataElement } from "@shared/models/common";
import { DocPhraseMergeAndReorder } from "@shared/models/doc-phrase-merge-and-reorder.model";
import { DocPhraseMergeAndReorderRequest } from "@shared/models/doc-phrase-merge-and-reorder.request";
import { NgRedux } from "@shared/redux/redux-compatibility.service";
import { AppState } from "@shared/redux/store";
import { ClaimToolService } from "@shared/services/claim-tool.service";

@Component({
    selector: 'doc-phrase-merge-and-reorder',
    templateUrl: './doc-phrase-merge-and-reorder.component.html',
    styleUrls: ['./doc-phrase-merge-and-reoder.component.scss'],
    standalone: false
})
export class DocPhraseMergeAndReorderComponent implements OnInit {

  @Input() docPhraseMergeAndReorderRequest: DocPhraseMergeAndReorderRequest;
  @Input() curPhraseId: number;
  @Input() splitExecuted: boolean = false;
  @Input() mergeExecuted: boolean = false;

  phrases: DocPhraseMergeAndReorder[] = [];
  loading = false;

  origContentTypeId: string = this.claimToolElement.contentType;
  origContentTypeDesc: string = this.claimToolElement.contentTypeDesc;

  constructor(private claimToolService: ClaimToolService,
    private ngRedux: NgRedux<AppState>
  ) {
        
  }
  
  ngOnInit(): void {
        
    this.loading = true;
      this.claimToolService.getOrderedPhrases(this.docPhraseMergeAndReorderRequest).subscribe(phrases => {
        this.phrases = phrases;
        this.loading = false;
        this.claimToolSaveChangesDataInitialValues.phrasesOrder = JSON.parse(JSON.stringify(phrases));
        this.claimToolElement.phrasesOrder = phrases;
      }, () => this.loading = false);
    }
  get claimToolElement() {
    return this.ngRedux.getState().claimToolElement;
  }

  get claimToolSaveChangesDataInitialValues(): ClaimToolElementSaveChangesData {
    
    return this.ngRedux.getState().claimToolSaveChangesDataInitialValues;
  }

  get contentTypesList(): DataElement[] {
    return this.ngRedux.getState().contentTypeList;
  }

  onCheckboxChange(checked, phrase: DocPhraseMergeAndReorder) {
      
    if (checked) {
      this.claimToolElement.mergedPhrases.push(phrase);
    } else {
      this.claimToolElement.mergedPhrases = this.claimToolElement.mergedPhrases.filter(mp => phrase.phrase_id != mp.phrase_id);
    }

    if (this.claimToolElement.mergedPhrases.some(p => p.phrase_content_type == "CLAIM")) {
      this.claimToolElement.contentType = "CLAIM";
      this.claimToolElement.contentTypeDesc = this.contentTypesList.find(ct => ct.id == "CLAIM").text;
    } else {
      this.claimToolElement.contentType = this.origContentTypeId;
      this.claimToolElement.contentTypeDesc = this.origContentTypeDesc;
    }

    this.claimToolService.mergedPhrasesChanged$.next(this.claimToolElement.mergedPhrases.length > 0);

  }

  
  onRowReorder(event) {
    if (this.mergeExecuted || this.splitExecuted) {
      return
    }
    const rowOrderChanged = this.claimToolService.checkPhraseOrderChanges(this.claimToolElement, this.claimToolSaveChangesDataInitialValues);
    this.claimToolService.phraseOrderChanged$.next(rowOrderChanged);
  }

}